import ExportReadyNotificationsComp from "./views/ExportReadyNotificationsComp";
import InboundCompletedNotificationsComp from "./views/InboundCompletedNotificationsComp";
import InvoiceProductZeroPriceNotificationsComp from "./views/InvoiceProductZeroPriceNotificationsComp";
import InvoiceReminderNotificationsComp from "./views/InvoiceReminderNotificationsComp";
import InvoiceCategoryChangedNotificationsComp from "./views/InvoiceCategoryChangedNotificationsComp";
import OrderActionRequiredWarehouseNotificationsComp from "./views/OrderActionRequiredWarehouseNotificationsComp";
import OrderNoPickstreamNotificationsComp from "./views/OrderNoPickstreamNotificationsComp";
import OrdersInBackorderNotificationsComp from "./views/OrdersInBackorderNotificationsComp";
import OrdersInMaintenanceNotificationsComp from "./views/OrdersInMaintenanceNotificationsComp";
import { OrderNotImportedNotificationsComp, OrdersNotImportedMissingProductsNotificationsComp } from "./views/OrdersNotImportedNotificationsComp";
import StockBelowSafetyNotificationsComp from "./views/StockBelowSafetyNotificationsComp";
import StockDifferenceNotificationsComp from "./views/StockDifferenceNotificationsComp";
import StockLowNotificationsComp from "./views/StockLowNotificationsComp";
import SystemNotifcationComponent from "./views/SystemNotifcationComponent";
import UnknownNotificationComponent from "./views/UnknownNotificationComponent";
import ReturnProcessedNotificationsComp from "./views/ReturnProcessedNotificationsComp";
import WebshopApprovalRequiredNotificationsComp from "./views/WebshopApprovalRequiredNotificationsComp";

export const NOTIFICATION_TYPES_MAP = {
    ORDERS: 'orders',
    INBOUND: 'inbound',
    STOCK_ALERTS: 'stock_alerts',
    SYSTEM: 'system',
}

export const NOTIFICATION_COMPONENTS = {
    order_in_backorder: {
        notifications_comp: OrdersInBackorderNotificationsComp,
    },
    order_in_maintenance: {
        notifications_comp: OrdersInMaintenanceNotificationsComp
    },
    orders_in_maintenance: {
        notifications_comp: OrdersInMaintenanceNotificationsComp
    },

    inbound_completed: {
        notifications_comp: InboundCompletedNotificationsComp,
    },
    inbound_incomplete_received: {
        notifications_comp: InboundCompletedNotificationsComp,
    },
    order_not_imported: {
        notifications_comp: OrderNotImportedNotificationsComp

    },
    stock_low : {
        notifications_comp: StockLowNotificationsComp,
    },
    orders_not_imported_missing_products: {
        notifications_comp: OrdersNotImportedMissingProductsNotificationsComp
    },
    minimum_stock: {
        notifications_comp: StockDifferenceNotificationsComp
    },
    stock_difference: {
        notifications_comp: StockDifferenceNotificationsComp
    },
    invoice_product_zero_price: {
        notifications_comp: InvoiceProductZeroPriceNotificationsComp
    },
    system: {
        notifications_comp: SystemNotifcationComponent
    },
    export_ready: {
        notifications_comp: ExportReadyNotificationsComp
    },
    orders_in_backorder: {
        notifications_comp: OrdersInBackorderNotificationsComp
    },
    order_action_required_warehouse: {
        notifications_comp: OrderActionRequiredWarehouseNotificationsComp
    },
    order_no_pickstream: {
        notifications_comp: OrderNoPickstreamNotificationsComp
    },
    stock_below_safety: {
        notifications_comp: StockBelowSafetyNotificationsComp
    },
    invoice_reminder: {
        notifications_comp: InvoiceReminderNotificationsComp
    },
    invoice_category_changed: {
        notifications_comp: InvoiceCategoryChangedNotificationsComp
    },
    webshop_approval_required: {
        notifications_comp: WebshopApprovalRequiredNotificationsComp
    },
    return_processed: {
        notifications_comp: ReturnProcessedNotificationsComp
    }
}

export const FALLBACK_NOTIFICATION_COMPONENT = {
    notifications_comp: UnknownNotificationComponent
}
